// File Metadata:
// Filename: QualityAssessmentForm.js
// Version: 1.00
// Created: 2025-03-23 01:05:24
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { Box, Tabs, Tab, Paper, Typography } from '@mui/material'
import { useState } from 'react'
import ChecklistSection from './ChecklistSection'
import QualityNotes from './QualityNotes'
import ApprovalActions from './ApprovalActions'
import QualityPhotos from './QualityPhotos'
import { QUALITY_STATUS } from '../../../config/qualityStatus'
import Grid from '@mui/material/Unstable_Grid2'

const QualityAssessmentForm = ({ reception }) => {
    const [tab, setTab] = useState(0)

    return (
        <Paper sx={{ p: 2, mt: 2 }}>
            <Grid container spacing={2}>
                {/* Status Banner */}
                <Grid xs={12}>
                    <Box sx={{ 
                        p: 1, 
                        bgcolor: QUALITY_STATUS[reception.qualityStatus]?.color || QUALITY_STATUS.PENDING.color,
                        color: 'white',
                        borderRadius: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <Typography variant="h6">
                            Status: {QUALITY_STATUS[reception.qualityStatus]?.label || 'Pending'}
                        </Typography>
                        <ApprovalActions 
                            receptionId={reception.id} 
                            currentStatus={reception.qualityStatus}
                        />
                    </Box>
                </Grid>

                {/* Main Content */}
                <Grid xs={12} md={8}>
                    <Tabs value={tab} onChange={(e, v) => setTab(v)}>
                        <Tab label="Checklist" />
                        <Tab label="Photos" />
                        <Tab label="Notes" />
                    </Tabs>
                    <Box sx={{ mt: 2 }}>
                        {tab === 0 && <ChecklistSection receptionId={reception.id} />}
                        {tab === 1 && <QualityPhotos receptionId={reception.id} />}
                        {tab === 2 && <QualityNotes receptionId={reception.id} />}
                    </Box>
                </Grid>

                {/* Sidebar */}
                <Grid xs={12} md={4}>
                    <Paper sx={{ p: 2, height: '100%' }}>
                        <Typography variant="h6" gutterBottom>Quality History</Typography>
                        {/* Add QualityTimeline component here */}
                    </Paper>
                </Grid>
            </Grid>
        </Paper>
    )
}

export default QualityAssessmentForm
